export const menuCategories = [
  {
    id: 'yogurt-chaats',
    name: 'Yogurt Based Premium Chaats',
    description: 'Creamy, tangy, and utterly delightful yogurt-based chaats',
    items: [
      {
        id: 'dahi-puri',
        name: 'Dahi Puri Delight',
        description: '8 Crispy puris filled with tangy yogurt, sweet & spicy chutneys, our special potato masala',
        price: 189,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/mlj6xb6g_Firefly_GeminiFlash_8%20pooris%20filled%20with%20curd%2C%20tamarin%20chutney%2C%20green%20chutney%2C%20sev%20and%20coriender%20in%20a%20bro%20104773.png',
        tags: ['Popular', 'Vegetarian'],
        available: true
      },
      {
        id: 'dahi-papdi',
        name: 'Signature Dahi Papdi Chaat',
        description: 'Our inhouse made Crunchy Khasta Papdi topped with smooth yogurt, chutney\'s, Sev and our special Chickpea masala.',
        price: 179,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/2elasdgd_Firefly_GeminiFlash_crushed%20papdi%20loaded%20with%20curd%2C%20tamarind%20chutney%2C%20green%20chutney%2C%20pomogranate%2C%20beetroo%20104773.png',
        tags: ['Chef Special', 'Vegetarian'],
        available: true
      },
      {
        id: 'raj-kachori',
        name: 'Raj Kachori Royale',
        description: 'King-size khasta Kachori filled with, vada, potatoes, sprouts, yogurt & tamarind and mint chutney. Tapped with sev and pomegranate for the complete royal experience',
        price: 199,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/9oh1145b_Raj%20kachori.jpeg',
        tags: ['Signature', 'Best Seller'],
        available: true
      },
      {
        id: 'boondi-raita',
        name: 'Boondi Raita Chaat Cup',
        description: 'Soft Boondi in spiced yogurt with fresh herbs and chutneys on boiled sprouted proteins for that perfect refreshing mini Snack. This is a dish made and sent as a layered cup.',
        price: 129,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/8c7s1x7n_freepik__boondi-raita-chaat-cup-yogurt-based-chaat-with-yel__2760.png',
        tags: ['Light', 'Refreshing'],
        available: true
      },
      {
        id: 'aloo-tikki',
        name: 'Tangy Aloo Tikki Chaat',
        description: 'Crispy potato patties with yogurt & tangy chutneys',
        price: 169,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/x970p0b6_Food%20photography-7c0b01c5-2728-41cf-85ef-50c34d79e396.jpg',
        tags: ['Classic', 'Filling'],
        available: true
      },
      {
        id: 'pani-puri-platter',
        name: 'Pani Puri Fun Platter',
        description: 'Crispy puris with tangy and spicy Pani, Date tamarind chutney and stuffing',
        price: 129,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/nqr2yyyo_Gemini_Generated_Image_gb7zvcgb7zvcgb7z.png',
        tags: ['Fun', 'Popular'],
        available: true
      },
      {
        id: 'special-mix',
        name: 'Chaat-De-licious Special Mix',
        description: 'Our signature mix of all premium ingredients',
        price: 249,
        image: 'https://images.unsplash.com/photo-1626776876729-bab4fe8fe0d7?crop=entropy&cs=srgb&fm=jpg&q=85',
        tags: ['Premium', 'Must Try'],
        available: false
      }
    ]
  },
  {
    id: 'fruit-chaats',
    name: 'Fruit & Refreshing Chaats',
    description: 'Fresh seasonal fruits with a chatpata twist',
    items: [
      {
        id: 'mango-zaika',
        name: 'Mango Zaika Chaat',
        description: 'Sweet mango chunks with mint, chaat masala and our special masala.',
        price: 199,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/n7drlyyw_Gemini_Generated_Image_79wfxz79wfxz79wf.png',
        tags: ['Seasonal', 'Sweet'],
        available: true
      },
      {
        id: 'pineapple-mint',
        name: 'Pineapple Mint Chaat',
        description: 'Tangy pineapple with fresh mint, lime and our special masala',
        price: 189,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/aq02cokl_Pineapple%20Mint%20Chaat.jpeg',
        tags: ['Tropical', 'Zesty'],
        available: true
      },
      {
        id: 'watermelon-masala',
        name: 'Watermelon Masala Cup',
        description: 'Juicy watermelon with black salt & spices',
        price: 159,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/ipu9vrmh_watermelon%20chaat%20cup.png',
        tags: ['Summer Special', 'Hydrating'],
        available: true
      },
      {
        id: 'papaya-watermelon',
        name: 'Papaya Watermelon Chaat',
        description: 'Fresh papaya and watermelon with pomegranate, lemon and our special spices',
        price: 189,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/nylpj2pg_Gemini_Generated_Image_gdfh7vgdfh7vgdfh.png',
        tags: ['Refreshing', 'Colorful'],
        available: true
      },
      {
        id: 'corn-pomegranate',
        name: 'Corn Pomegranate Chaat',
        description: 'Sweet corn with juicy pomegranate & tangy dressing',
        price: 149,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/7yaec2pu_corn%20pomogranate%20chaat.png',
        tags: ['Crunchy', 'Colorful'],
        available: true
      },
      {
        id: 'mixed-fruit',
        name: 'Mixed Seasonal Fruit Chaat',
        description: 'Assorted seasonal fruits with tangy spice mix',
        price: 189,
        image: 'https://images.unsplash.com/photo-1559058922-94684b5cd9b8?crop=entropy&cs=srgb&fm=jpg&q=85',
        tags: ['Healthy', 'Fresh'],
        available: false
      }
    ]
  },
  {
    id: 'healthy-chaats',
    name: 'Healthy / Protein Chaats',
    description: 'Nutritious chaats packed with protein and fiber',
    items: [
      {
        id: 'sprouts-protein',
        name: 'Sprouts Protein Chaat',
        description: 'Mixed sprouts with veggies & tangy dressing',
        price: 169,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/41thj0hq_Firefly_GeminiFlash_moong%20sprouts%20chaat-%20Moong%20sprouts%2C%20finely%20cut%20cucumber%2C%20puffed%20rice%2C%20roasted%20peanuts%20104773.png',
        tags: ['High Protein', 'Fiber Rich'],
        available: true
      },
      {
        id: 'sweet-corn',
        name: 'Sweet Corn Delight Chaat',
        description: 'Boiled corn kernels with butter & spice mix',
        price: 179,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/tmc4bdu4_Gemini_Generated_Image_iwztoyiwztoyiwzt.png',
        tags: ['Kids Favorite', 'Wholesome'],
        available: true
      },
      {
        id: 'cucumber-mint',
        name: 'Cucumber Mint Chaat',
        description: 'Fresh cucumber with veggies, roasted peanuts, pomegranate, mint and tamarind chutney our inhouse masala and lemon make for a refreshing, healthy and light chaat.',
        price: 129,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/jhr8kzsn_Food%20photography-7138d06f-4568-4926-944b-d140ba628801.jpg',
        tags: ['Low Calorie', 'Cooling'],
        available: true
      },
      {
        id: 'moong-dal',
        name: 'Moong Dal Protein Chaat',
        description: 'Half boiled moong dal with onions, tomatoes, cucumber & spices, chutneys and garnish make it a protein rich traditional yet perfect fusion meal for summers.',
        price: 179,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/icxq6pc9_yellow%20moong%20dal%20chaat.png',
        tags: ['Protein Packed', 'Crunchy'],
        available: true
      },
      {
        id: 'chana-chaat',
        name: 'Chana Chaat',
        description: 'Boiled chickpeas and kala chana, with potatoes, tangy spices in a curd and mint base makes it a super fun protein bowl.',
        price: 129,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/9b2946lf_chana%20chaat.png',
        tags: ['Protein Rich', 'Classic'],
        available: true
      },
      {
        id: 'boiled-peanut',
        name: 'Boiled Peanut Chaat',
        description: 'Protein-rich boiled peanuts with fresh veggies and fresh fruits in a tangy /sweet/spicy dressing makes our chef special a must try chaat.',
        price: 129,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/xeinf0mu_boiled%20peanut.png',
        tags: ['High Protein', 'Filling'],
        available: true
      },
      {
        id: 'rainbow-veg',
        name: 'Rainbow Veg Crunch Chaat',
        description: 'Colorful mix of fresh vegetables & nuts',
        price: 249,
        image: 'https://images.unsplash.com/photo-1598235002272-7ab27e3c7fde?crop=entropy&cs=srgb&fm=jpg&q=85',
        tags: ['Nutritious', 'Colorful'],
        available: false
      }
    ]
  },
  {
    id: 'summer-coolers',
    name: 'Signature Summer Coolers',
    description: 'Refreshing beverages to beat the heat',
    items: [
      {
        id: 'aam-panna',
        name: 'Aam Panna Refresher',
        description: 'Traditional raw mango drink with mint',
        price: 149,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/vf8tafnw_Aam%20Panna.jpeg',
        tags: ['Traditional', 'Cooling'],
        available: true
      },
      {
        id: 'rose-basil',
        name: 'Rose Basil Shikanji',
        description: 'Lemonade infused with rose & basil',
        price: 129,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/p7dnjufh_Rose%20Basil%20Shikanji.png',
        tags: ['Aromatic', 'Refreshing'],
        available: true
      },
      {
        id: 'thandai-chiller',
        name: 'Dry Fruit Thandai Chiller',
        description: 'Rich thandai with almonds & pistachios',
        price: 179,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/tywyl3ze_thandai.png',
        tags: ['Premium', 'Nutty'],
        available: true
      },
      {
        id: 'nimbu-shikanji',
        name: 'Nimbu Shikanji',
        description: 'Classic lemon drink with fresh mint & spices',
        price: 129,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/woce2i5v_Gemini_Generated_Image_lm0q2mlm0q2mlm0q%20%281%29.png',
        tags: ['Classic', 'Refreshing'],
        available: true
      },
      {
        id: 'paan-chia-cooler',
        name: 'Paan Chia Cooler',
        description: 'Fresh paan, with fennel sheeds, cardamom, chia seeds & rose makes for a refreshing drink with any chaat.',
        price: 149,
        image: 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/jjjvunti_Gemini_Generated_Image_u0xiz3u0xiz3u0xi.png',
        tags: ['Unique', 'Healthy'],
        available: true
      },
      {
        id: 'paan-shots',
        name: 'Paan Shots',
        description: 'Digestive paan flavored shots',
        price: 149,
        image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?crop=entropy&cs=srgb&fm=jpg&q=85',
        tags: ['Digestive', 'Traditional'],
        available: false
      }
    ]
  }
];
